import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  payNow: 'Pay Now',
  visaTitle: 'Visa Card',
  saveCardData: 'Save Card Data',
  planSummary: 'Plan Summary ',
  changePlan: 'Change Plan',
  automaticRenewalMonthly: 'Monthly auto-renewal. Cancel whenever you wish.',
  automaticRenewal:
    'Auto-renewal every {{duration}} months. Cancel whenever you wish.',
  nonAutoRenewal: 'One-month subscription only with no auto-renewal.',
  totalFees: 'Total Fees',
  selectPlane: 'Select your perfect plan',
  selectPlanDescription:
    'Select the plan you need and enjoy exclusive benefits with our lowest price offers',
  benefits: 'Benefits:',
  pointsValue: '{{value}} Points',
  point: 'Point',
  addAndFeaturingAds: ' (add and feature properties)',
  pointsExpiry: 'Points Expiry:',
  expiryDays: '{{number}} Days',
  subscribeNow: 'Subscribe Now',
  mostSell: 'Most Sell',
  noPlansFound: 'No available plans to subscribe',
  recommended: 'Recommended',
  bestSeller: 'Best Seller',
  biggestDiscount: 'Biggest Discount',
  specialOffer: 'Special Offer',
  bestForBranding: 'Best for Branding',
  addPaymentCard: 'Add New Card',
  freeTrialDays: '{{days}} days free trail',
  freeTrial: 'Free Trail :  <tag>{{price}} EGP for {{days}}  days</tag>',
  freeTrialStartDate: 'start from {{date}}: <tag>{{price}} EGP/month</tag>',
  duplicateTrial: 'free trail cannot used more than once ',
  aqarmap: 'Aqarmap',
  toAddListings: 'To add listing',
  noPropertyListing: "Doesn't include property listing.",
  month: 'Month',
  months: 'Months',
  saveIt: 'Save',
  planPrice: 'Plan Price',
  discountPercentage: 'Package with {{percentage}}% discount',
  subscriptionQuarterly: 'Quarterly',
  subscriptionYearly: 'Yearly',
  subscriptionSave50: 'Save 50%',
  subscriptionPriceWithPeriod:
    '<price>{{price}} {{unit}}</price><period>{{period}}</period>',
});
